import React, { memo } from 'react'
import { SmartWayCarrierModal } from 'transfix-form/forms/SmartWayCarrier/components'
import {
  getSmartWayCarrierDefaultValues,
  getSmartWayCarrierLabels,
} from 'transfix-form/forms/SmartWayCarrier/utils'
import Card from 'transfix-ui/components/Card'
import Typography from 'transfix-ui/core/Typography'
import { useModalState } from 'utils/hooks'
import CarrierProfileCardRow from '../CarrierProfileCardRow'
import { ISmartWayCarrierFragment } from './graphql/SmartWayCarrierFragment'
import { useSmartWayCarrierSubmitter } from './hooks'

export interface ISmartWayCarrierCardProps extends ISmartWayCarrierFragment {}

const SmartWayCarrierCard = memo<ISmartWayCarrierCardProps>(
  ({ id: motorCarrierId, smartWayRegistration }) => {
    const { createToggleHandler, modalState } = useModalState({
      smartWayCarrierModal: false,
    })

    const { loading, submitHandler } = useSmartWayCarrierSubmitter(motorCarrierId)

    const { smartWayCarrierModal: isSmartWayCarrierModalOpen } = modalState || {}
    const toggleSmartWayCarrierModalHandler = createToggleHandler('smartWayCarrierModal')

    const { registeredLabel, renewalDateLabel } = getSmartWayCarrierLabels(smartWayRegistration)
    const smartWayDefaultValues = getSmartWayCarrierDefaultValues(smartWayRegistration)

    return (
      <Card>
        <Typography variant='h3' align='left'>
          SmartWay Carrier
        </Typography>
        <Typography variant='body2' align='left'>
          The SmartWay Program helps carriers demonstrate their efficiency achievements, show
          continuous improvement, and learn best practices to become even better.
        </Typography>
        <CarrierProfileCardRow
          title='Are you a SmartWay Carrier?'
          value={
            <>
              <Typography component='div' variant='body1'>
                {registeredLabel}
              </Typography>
              <Typography component='div' variant='body1' color='textSecondary'>
                {renewalDateLabel}
              </Typography>
            </>
          }
          onEdit={toggleSmartWayCarrierModalHandler}
          showBorder={false}
        />
        {isSmartWayCarrierModalOpen && (
          <SmartWayCarrierModal
            defaultValues={smartWayDefaultValues}
            loading={loading}
            onClose={toggleSmartWayCarrierModalHandler}
            onSubmit={submitHandler}
          />
        )}
      </Card>
    )
  }
)

export default SmartWayCarrierCard
